import { Suspense } from 'react'
import { RouterProvider } from 'react-router-dom'
import { FullPageSpinner } from '@trinity/components'
import { router } from 'routes'

function App() {
  return (
    <Suspense fallback={<FullPageSpinner />}>
      <RouterProvider router={router} />
    </Suspense>
  )
}

export default App
